(function () {
  'use strict';
  function initialize() {
  var bar = document.getElementById('ilk-mobile-sticky-cart');
  var dataNode = document.getElementById('ilk-mobile-cart-data');
  if (!bar || !dataNode) return;
  if (bar.ilkDestroy) bar.ilkDestroy();
  var form = document.querySelector('[data-section-type="product-template"] form.product-single__form');
  if (!form) return;
  var nativeAdd = form.querySelector('button[name="add"]');
  var section = form.closest('[data-section-type="product-template"]');
  var nativePrice = section.querySelector('#ProductPrice');
  if (!nativeAdd || !nativePrice) return;
  bar.dataset.initialized = 'true';
  var controller = new AbortController();
  var observers = [];
  function listen(target, event, handler, options) {
    target.addEventListener(event, handler, Object.assign({}, options || {}, { signal: controller.signal }));
  }
  function observe(target, options) {
    var observer = new MutationObserver(schedule);
    observer.observe(target, options);
    observers.push(observer);
  }
  var data = JSON.parse(dataNode.textContent);
  var add = bar.querySelector('[data-ilk-add]');
  var addLabel = bar.querySelector('[data-ilk-add-label]');
  var variantText = bar.querySelector('[data-ilk-variant]');
  var priceText = bar.querySelector('[data-ilk-price]');
  var thumbnail = bar.querySelector('[data-ilk-thumbnail]');
  var status = document.getElementById('ilk-mobile-cart-status');
  var mobile = window.matchMedia('(max-width: 769px)');
  var pending = false;
  var activeRequest = null;
  var dispatching = false;
  var allowSubmit = false;
  var submittedEvent = null;
  var frame = 0;
  var options = bar.querySelector('[data-ilk-options]');
  var observedCookies = new WeakSet();
  var observedChatRoots = new WeakSet();
  var observedPreviewFrames = new WeakSet();
  var cookieSelector = '#shopify-pc__banner, #shopify-privacy-banner-div, #CookieBox, .shopify-pc__banner__dialog';

  function selectedVariant() {
    var controls = Array.from(form.querySelectorAll('.single-option-selector__radio')).filter(function (control) {
      return control.type !== 'radio' && control.type !== 'checkbox' || control.checked;
    });
    if (controls.length) {
      return data.variants.find(function (variant) {
        return controls.every(function (control) { return variant[control.dataset.index] === control.value; });
      });
    }
    var master = form.querySelector('[name="id"]');
    return master && data.variants.find(function (variant) { return String(variant.id) === master.value; });
  }

  function visible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function chatIsOpen() {
    var open = false;
    function inspect(root) {
      if (!observedChatRoots.has(root)) {
        observedChatRoots.add(root);
        chatObserver.observe(root, { attributes: true, attributeFilter: ['aria-expanded', 'hidden', 'open', 'class', 'style'], childList: true, subtree: true });
      }
      if (root.shadowRoot) inspect(root.shadowRoot);
      Array.from(root.querySelectorAll('*')).forEach(function (element) {
        if (element.matches('button[aria-expanded="true"], [role="dialog"], dialog[open]') && visible(element)) open = true;
        if (element.shadowRoot) inspect(element.shadowRoot);
      });
    }
    Array.from(document.querySelectorAll('shopify-chat')).forEach(inspect);
    return open;
  }

  function previewToolbarOffset() {
    var offset = 0;
    Array.from(document.querySelectorAll('#preview-bar-iframe, #PBarNextFrame')).forEach(function (frameElement) {
      var preview = frameElement.id === 'PBarNextFrame' ? document.getElementById('PBarNextFrameWrapper') || frameElement : frameElement;
      if (!observedPreviewFrames.has(preview)) {
        observedPreviewFrames.add(preview);
        previewObserver.observe(preview, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'height', 'width'] });
        if (previewResizeObserver) previewResizeObserver.observe(preview);
      }
      if (visible(preview)) {
        offset = Math.max(offset, Math.ceil(window.innerHeight - Math.max(0, preview.getBoundingClientRect().top)));
      }
    });
    return offset;
  }

  function setText(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }

  function showLoadedThumbnail() {
    if (thumbnail && !thumbnail.hidden && thumbnail.complete && thumbnail.naturalWidth > 0 && (thumbnail.currentSrc || thumbnail.src) === thumbnail.src) {
      thumbnail.style.visibility = 'visible';
    }
  }

  function updateThumbnail(variant) {
    if (!thumbnail) return;
    var source = variant && data.variantImages && data.variantImages[String(variant.id)];
    thumbnail.hidden = !source;
    if (!source) {
      thumbnail.removeAttribute('src');
      thumbnail.alt = '';
      thumbnail.style.visibility = 'hidden';
      return;
    }
    thumbnail.alt = data.title + (data.defaultVariant ? '' : ': ' + variant.title);
    if (thumbnail.getAttribute('src') !== source) {
      thumbnail.style.visibility = 'hidden';
      thumbnail.setAttribute('src', source);
    }
    showLoadedThumbnail();
  }

  if (thumbnail) {
    listen(thumbnail, 'load', showLoadedThumbnail);
    listen(thumbnail, 'error', function () { thumbnail.style.visibility = 'hidden'; });
  }

  function update() {
    frame = 0;
    if (!form.isConnected) { bar.hidden = true; document.body.classList.remove('ilk-mobile-cart-visible'); return; }
    var variant = selectedVariant();
    var quantity = form.querySelector('[name="quantity"]');
    var quantityValue = quantity ? quantity.value : '1';
    var master = form.querySelector('[name="id"]');
    var matches = !!(variant && master && master.value === String(variant.id));
    var busy = pending || nativeAdd.classList.contains('is-adding');
    var disabled = !variant || !variant.available || !matches || nativeAdd.disabled || busy;
    var label = busy ? data.labels.adding : !variant ? data.labels.unavailable : !variant.available ? data.labels.soldOut : data.labels.add;
    var selected = variant ? (data.defaultVariant ? data.title : variant.title) : data.labels.unavailable;
    setText(variantText, selected);
    updateThumbnail(variant);
    setText(priceText, variant ? nativePrice.textContent.trim() + ' ' + data.currency + (quantityValue !== '1' ? ' · ' + data.labels.quantity + ' ' + quantityValue : '') : '');
    setText(addLabel, label);
    add.disabled = disabled;
    add.setAttribute('aria-busy', busy ? 'true' : 'false');
    add.setAttribute('aria-label', label + ': ' + selected);
    bar.dataset.variantId = variant ? String(variant.id) : '';
    var previewOffset = previewToolbarOffset();
    document.body.style.setProperty('--ilk-preview-offset', previewOffset + 'px');
    var cookies = Array.from(document.querySelectorAll(cookieSelector));
    cookies.forEach(function (cookie) {
      if (!observedCookies.has(cookie)) {
        observedCookies.add(cookie);
        cookieObserver.observe(cookie, { attributes: true, childList: true, subtree: true });
      }
    });
    var cookieOpen = cookies.some(visible);
    var chatOpen = chatIsOpen();
    var overlayOpen = document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open') || !!document.querySelector('.mfp-ready');
    var editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName) && !form.contains(document.activeElement);
    var passed = nativeAdd.getBoundingClientRect().bottom <= 0;
    var shouldShow = mobile.matches && passed && !cookieOpen && !chatOpen && !overlayOpen && !editing;
    bar.hidden = !shouldShow;
    document.body.classList.toggle('ilk-mobile-cart-visible', shouldShow);
    if (shouldShow) document.body.style.setProperty('--ilk-mobile-cart-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  listen(options, 'click', function () {
    var target = form.querySelector('.single-option-selector__radio:not([disabled])') || form.querySelector('[name="quantity"]') || nativeAdd;
    if (!target.getClientRects().length) {
      target = form;
      form.setAttribute('tabindex', '-1');
      if (!form.hasAttribute('aria-label')) form.setAttribute('aria-label', data.title);
    }
    form.scrollIntoView({ behavior: 'auto', block: 'center' });
    target.focus({ preventScroll: true });
    schedule();
  });

  listen(form, 'submit', function (event) {
    if (!pending) return;
    if (allowSubmit || (submittedEvent && submittedEvent.defaultPrevented && !activeRequest && !nativeAdd.classList.contains('is-adding'))) { allowSubmit = false; submittedEvent = event; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, { capture: true });

  listen(add, 'click', function () {
    update();
    if (add.disabled || pending || !form.reportValidity()) return;
    pending = true;
    allowSubmit = true;
    submittedEvent = null;
    setText(status, data.labels.adding);
    update();
    dispatching = true;
    nativeAdd.click();
    dispatching = false;
    if (allowSubmit || (submittedEvent && submittedEvent.defaultPrevented && !activeRequest && !nativeAdd.classList.contains('is-adding'))) {
      allowSubmit = false;
      pending = false;
      schedule();
    }
  });

  listen(form, 'change', schedule);
  listen(form, 'input', schedule);
  listen(form, 'click', schedule);
  listen(window, 'scroll', schedule, { passive: true });
  listen(window, 'resize', schedule, { passive: true });
  listen(window, 'pageshow', function () { pending = false; activeRequest = null; schedule(); });
  listen(document, 'focusin', schedule);
  listen(document, 'focusout', schedule);
  listen(document, 'click', schedule, { capture: true });
  listen(mobile, 'change', schedule);
  if (window.visualViewport) listen(window.visualViewport, 'resize', schedule);
  var intersection = new IntersectionObserver(schedule);
  intersection.observe(nativeAdd);
  observers.push(intersection);
  observe(nativeAdd, { attributes: true, childList: true, subtree: true });
  observe(nativePrice, { childList: true, characterData: true, subtree: true });
  observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  var previewObserver = new MutationObserver(schedule);
  observers.push(previewObserver);
  var previewResizeObserver = typeof window.ResizeObserver === 'function' ? new window.ResizeObserver(schedule) : null;
  if (previewResizeObserver) observers.push(previewResizeObserver);
  var cookieObserver = new MutationObserver(schedule);
  observers.push(cookieObserver);
  var chatObserver = new MutationObserver(schedule);
  observers.push(chatObserver);
  if (window.jQuery) {
    window.jQuery(section).on('variantChange.ilkMobileCart variantPriceChange.ilkMobileCart', schedule);
    window.jQuery(document).on('ajaxSend.ilkMobileCart', function (event, xhr, settings) {
      if (pending && dispatching && settings.data === window.jQuery(form).serialize() && /\/cart\/add(?:\.js)?(?:\?|$)/.test(settings.url)) activeRequest = xhr;
    });
    window.jQuery(document).on('ajaxComplete.ilkMobileCart', function (event, xhr) {
      if (!pending || xhr !== activeRequest) return;
      pending = false;
      activeRequest = null;
      setText(status, xhr.status >= 200 && xhr.status < 300 ? data.labels.added : data.labels.error);
      schedule();
    });
  }
  bar.ilkDestroy = function () {
    controller.abort();
    observers.forEach(function (observer) { observer.disconnect(); });
    window.cancelAnimationFrame(frame);
    if (window.jQuery) {
      window.jQuery(section).off('.ilkMobileCart');
      window.jQuery(document).off('.ilkMobileCart');
    }
    bar.hidden = true;
    document.body.classList.remove('ilk-mobile-cart-visible');
    delete bar.dataset.initialized;
    delete bar.ilkDestroy;
  };
  update();
  }
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector && event.target.querySelector('form.product-single__form')) {
      var bar = document.getElementById('ilk-mobile-sticky-cart');
      if (bar && bar.ilkDestroy) bar.ilkDestroy();
    }
  });
  initialize();
}());
